/**
 * Modules slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';
import { Module } from '../../store/slices/types';

const initialState = {
  modules: [] as Module[],
  currentModule: null as Module | null,
  loading: false,
  error: null as string | null,
  uploadProgress: 0,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
  },
};

const modulesSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    setModules(state, action) {
      // Handle both array response and paginated response
      if (Array.isArray(action.payload)) {
        state.modules = action.payload;
      } else if (action.payload?.data) {
        state.modules = action.payload.data;
        if (action.payload.pagination) {
          state.pagination = {
            total: action.payload.pagination.total || action.payload.total || 0,
            page: action.payload.pagination.page || action.payload.page || 1,
            limit: action.payload.pagination.limit || action.payload.limit || 10,
          };
        }
      } else {
        state.modules = [];
      }
      state.loading = false;
      state.error = null;
    },
    setCurrentModule(state, action) {
      state.currentModule = action.payload;
      state.loading = false;
      state.error = null;
    },
    addModule(state, action) {
      state.modules.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    updateModule(state, action) {
      const index = state.modules.findIndex(
        (m) => (m._id || m.id) === (action.payload._id || action.payload.id)
      );
      if (index !== -1) {
        state.modules[index] = action.payload;
      }
      if (state.currentModule && (state.currentModule._id || state.currentModule.id) === (action.payload._id || action.payload.id)) {
        state.currentModule = action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    removeModule(state, action) {
      state.modules = state.modules.filter(
        (m) => (m._id || m.id) !== action.payload
      );
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
    setUploadProgress(state, action) {
      state.uploadProgress = action.payload;
    },
    clearUploadProgress(state) {
      state.uploadProgress = 0;
    },
  },
});

// Reducer
export const modulesReducer = modulesSlice.reducer;

// Actions
export const {
  setModules,
  setCurrentModule,
  addModule,
  updateModule,
  removeModule,
  setLoading,
  setError,
  clearError,
  setUploadProgress,
  clearUploadProgress,
} = modulesSlice.actions;

// Async Actions
export const fetchModules = createAction<{ page?: number; limit?: number; activeOnly?: boolean } | undefined>('MODULES/FETCH_ALL');
export const fetchModule = createAction<string>('MODULES/FETCH_ONE');
export const createModule = createAction<Omit<Module, '_id' | 'id'>>('MODULES/CREATE');
export const updateModuleAction = createAction<{ id: string; data: Partial<Module> }>('MODULES/UPDATE');
export const deleteModule = createAction<string>('MODULES/DELETE');
export const uploadModuleVideo = createAction<{ id: string; file: File }>('MODULES/UPLOAD_VIDEO');

